<template lang="pug">


  .goo-pagination
    svg(viewBox="0 0 18 180" xmlns="http://www.w3.org/2000/svg")
      g(filter="url(#goo)")
        //use.moving-dot(xlink:href="#dot-small-1" :transform="`translate(0 ${36*(currSceneIdx)}) scale(1)`")
        use.moving-dot(ref="movingDot" xlink:href="#dot-small-1")
        template(v-for="i in length")
          //use.outer(:ref="'outer'+(i-1)" xlink:href="#dot-large" :transform="`${currSceneIdx === i-1? `translate(0 ${36*(i-1)}) scale(1)`: `translate(4.5 ${36*(i-1)+4.5}) scale(0.5)`}`")
          //use.inner(:ref="'inner'+(i-1)" :xlink:href="`#dot-small-${i%4+1}`" :transform="`${currSceneIdx === i-1? `translate(0 ${36*(i-1)}) scale(1)`: `translate(9 ${36*(i-1)+9}) scale(0)`}`")
          use.outer(:ref="'outer'+(i-1)" xlink:href="#dot-large" :transform="`translate(${4.5*t[`t${i}1`]} ${36*(i-1)+4.5*t[`t${i}1`]}) scale(${1-0.5*t[`t${i}1`]})`")
          use.inner(:ref="'inner'+(i-1)" :xlink:href="`#dot-small-${i%4+1}`" :transform="`translate(${9*t[`t${i}2`]} ${36*(i-1)+9*t[`t${i}2`]}) scale(${1-t[`t${i}2`]})`")

</template>

<script>
  import { mapState, mapMutations } from 'vuex'
export default {
  name: 'goo-pagination',
  components: {},
  data() {
    return {
      t:{
        t11: 1,
        t12: 1,
        t21: 1,
        t22: 1,
        t31: 1,
        t32: 1,
        t41: 1,
        t42: 1,
        t51: 1,
        t52: 1,
      },
      lastIdx: 0

    }
  },
  props: {
    length: {

      default: 5
    }
  },
  computed: {
    ...mapState('app', ['currSceneIdx', 'mode']),

  },
  mounted() {
    this.animeIn(this.currSceneIdx, 1)
    // let tl = new TimelineMax({ onComplete: () => {
    //   }
    // })
    // this.tl = tl
    // tl.add('start')
    //   .set(
    //     this.$refs.movingDot,
    //     {
    //       y: 36*this.currSceneIdx,
    //     },
    //     `start+=0`
    //   )
    //   .to(
    //     this.t,
    //     0.7,
    //     {
    //       [`t${this.currSceneIdx+1}1`]: 0,
    //       ease: Power2.easeOut
    //     },
    //     `start+=0`
    //   )
    //   .to(
    //     this.t,
    //     0.7,
    //     {
    //       [`t${this.currSceneIdx+1}2`]: 0,
    //       ease: Power2.easeOut
    //     },
    //     `start+=0.3`
    //   )
    this.lastIdx = this.currSceneIdx
  },
  beforeDestroy() {},
  methods: {
    animeIn(id, delay){
      let tl = new TimelineMax({
        delay: delay,
        onComplete: () => {
        }
      })
      this.tl = tl
      tl.add('start')
        .set(
          this.$refs.movingDot,
          {
            y: 36*id,
          },
          `start+=0`
        )
        .set(
          this.$el,
          {
            x: 100,
          },
          `start+=0`
        )
        .to(
          this.t,
          0.7,
          {
            [`t${id+1}1`]: 0,
            ease: Power2.easeOut
          },
          `start+=0.3`
        )
        .to(
          this.t,
          0.7,
          {
            [`t${id+1}2`]: 0,
            ease: Power2.easeOut
          },
          `start+=0.4`
        )
        .to(
          this.$el,
          0.7,
          {
            x: 0,
            ease: Power2.easeOut
          },
          `start+=0`
        )
    },
    animeOut(id){
      let tl = new TimelineMax({ onComplete: () => {
        }
      })
      this.tl = tl
      tl.add('start')
        .to(
          this.t,
          0.7,
          {
            [`t${id+1}1`]: 1,
            ease: Power2.easeOut
          },
          `start+=0.3`
        )
        .to(
          this.t,
          0.7,
          {
            [`t${id+1}2`]: 1,
            ease: Power2.easeOut
          },
          `start+=0`
        )
        .to(
          this.$el,
          0.7,
          {
            x: 100,
            ease: Power2.easeIn
          },
          `start+=0`
        )
    }
  },
  watch: {
    currSceneIdx(val){
      if (this.tl) {
        this.tl.seek(this.tl.endTime())
        this.tl.kill()
        this.tl = null
      }
      // this.$refs.dot.style.opacity = 1
      // let top = this.$refs.slots[val].getBoundingClientRect().top
      // this.$refs.dot.style.transform = `translate3d(0, ${top}px, 0)`


      // let currInner = this.$refs['inner'+currIdx]
      // let lastInner = this.$refs['inner'+lastIdx]
      // let currOuter = this.$refs['outer'+currIdx]
      // let lastOuter = this.$refs['outer'+lastIdx]
      //console.log(this.lastIdx, val)


      if (this.lastIdx === val) {

        this.animeIn(val, 0)
        // if (this.mode === 0) {
        //   window.ButtonMenu.show()
        // }
        window.ButtonMenu.show()
        return
      }

      if (val === 5) {
        // if (this.mode === 0) {
        //   window.ButtonMenu.hide()
        // }
        window.ButtonMenu.hide()

        this.animeOut(this.lastIdx)


      }else{
        let tl = new TimelineMax({ onComplete: () => {
          }
        })
        this.tl = tl
        tl.add('start')
          .to(
            this.$refs.movingDot,
            0.7,
            {
              y: 36*val,
              ease: Power2.easeOut
            },
            `start+=0`
          )
          .to(
            this.t,
            0.7,
            {
              [`t${this.lastIdx+1}1`]: 1,
              ease: Power2.easeOut
            },
            `start+=0.3`
          )
          .to(
            this.t,
            0.7,
            {
              [`t${this.lastIdx+1}2`]: 1,
              ease: Power2.easeOut
            },
            `start+=0`
          )
          .to(
            this.t,
            0.7,
            {
              [`t${val+1}1`]: 0,
              ease: Power2.easeOut
            },
            `start+=0`
          )
          .to(
            this.t,
            0.7,
            {
              [`t${val+1}2`]: 0,
              ease: Power2.easeOut
            },
            `start+=0.3`
          )


        this.lastIdx = val

      }
      //console.log(currIdx, lastIdx, this.t.t11, this.t.t12)
    }
  },
}
</script>

<style lang="sass" scoped>
@import "src/styles/common.sass"
.goo-pagination

  width: 0.2rem
  height: 100%
  position: absolute
  right: 0.1rem
  top: 0
  display: flex
  justify-content: center
  align-items: center
  flex-direction: column

  //overflow: hidden

  .moving-dot
    fill: $cl-white
    //position: absolute
    //transition: all 0.5s ease-out
    //transform-origin: center
    //top: 0
    //left: 0
    //z-index: 9
    //opacity: 0
    //use
      transform-origin: center
      transform: scale(1.2)

  //.slot
    margin: 0.2rem 0 0.2rem 0
    width: 100%
    z-index: 10
    position: relative
  .outer
    //filter: url('#goo')
    fill: $cl-white
    //transform: scale(0.5)
    //transform-origin: center
    //transition: all 0.5s ease-out 0.3s

    &.active
      //transform: scale(1)
      //transition: all 0.5s ease-out
  .inner

    fill: #E38203
    //transform: scale(0)
    //transform-origin: center
    //transition: all 0.5s ease-out
    &.active
      //transform: scale(1)
      //transition: all 0.5s ease-out 0.3s









</style>
